<nwm-menu #menu />
<div class="content content-white-section" [ngClass]="{prelogin:!menu.user}">
  <div class="flex-margin"></div>
  <div class="white-section mt-5 py-3 px-lg-5 px-md-4 px-3">
    <h1 class="section-header">{{titles[error!]}}</h1>

    @if (error === '1') {
      <p>
        Your account is locked.<br />
        <br />
        Please contact <a href="mailto:{{supportEmail}}">{{supportEmail}}</a>
      </p>
    }

    @if (error === '2') {
      <p>
        We apologize for any inconvenience, but the link you’ve used is no longer valid or has expired.<br><br>
        If there is information you required immediately, please feel free to contact your
        Advisory Team during business hours at 604-739-6450 or email our support team at
        <a href="mailto:{{supportEmail}}">{{supportEmail}}</a>
      </p>
    }

    @if (error === '3') {
      <p>
        You have reached the maximum number of password attempts.<br />
        For your protection, this account has been locked. Please click<br />
        below to have your password reset.<br /><br />
        <a class="btn btn-primary" [routerLink]="['/account/passwordreset/self']" style="width: 180px">Password Reset</a>
      </p>
    }

    @if (error === 'passwordChanged') {
      <p>
        Please login again.<br /><br />
        <a class="btn btn-primary" [routerLink]="['/account/login']" style="width: 180px">Login</a>
      </p>
    }

    @if (error === '4' || error === '5') {
      <p>
        It appears you have not completed your account setup process.<br><br>
        Please check your inbox for an email with the subject line <i>"Welcome to Nicola Wealth’s Private Client Access site"</i> and go through the account activation process.<br><br>
        Alternatively, you can contact <a href="mailto:{{supportEmail}}">{{supportEmail}}</a> to have your account reset.
      </p>
    }
    @if (error === '6') {
      <p>
        It appears that more than one account is linked to your email address.<br><br>
        Unfortunately, we are unable to identify which username you want to retrieve.
        Please contact <a href="mailto:{{supportEmail}}">{{supportEmail}}</a> specifying which account you would like to access and we can retrieve your username(s) for you.
      </p>
    }
    @if (error === '7') {
      <p>
        We apologize for the temporary disruption in service. Our Private Client Access site is currently unavailable but will become available again shortly, so please check back soon.<br><br>
        If there is information you require immediately, please feel free to contact your Advisory Team or e-mail our support team at <a href="mailto:{{supportEmail}}">{{supportEmail}}</a>
      </p>
    }
    @if (error === '8') {
      <p>
        We're sorry, but the page you're looking for does not exist
      </p>
    }
    @if (error === '9') {
      <p>
        Please accept our apologies.<br><br>
        Our Private Client Access website is currently unavailable.
      </p>
    }
    @if (error === '10') {
      <p>
        It appears your browser is not supported by our site.<br>Please try another browser or see
        if a new version of your preferred browser is available.
      </p>
    }

    <p>&nbsp;</p>
    <nwm-awards />
  </div>

</div>
